// user_mass_actions_controller.js
import ApplicationController from "./application_controller";

export default class SecureFieldEditController extends ApplicationController {
  static targets = [
    'displayField',
    'editField',
    'editFieldContainer',  // Field and its container can be same too
    'editBtn',
    'deleteFieldContainer',
    'toggleFieldValueVisibility',
    'toggleFieldType'
  ]
  
  initialize(){
  }

  displayViewOnlyField(){
    // Updating value in the displayField - START
    let newValue         = this.editFieldTarget.value;
    if (!newValue){
      return;
    }

    let newValueLastFive = newValue.slice(-5); // Get last 5 characters
    this.displayFieldTarget.value = "********************" + newValueLastFive;
    // Updating value in the displayField - END


    this.editFieldContainerTarget.classList.toggle('d-none', true)
    if (this.hasToggleFieldTypeTarget){
      this.toggleFieldTypeTarget.classList.toggle('d-none', true)
    }

    this.editBtnTarget.classList.toggle('d-none', false)
    this.displayFieldTarget.classList.toggle('d-none', false)
    if (this.hasDeleteFieldContainerTarget){
      this.deleteFieldContainerTarget.classList.toggle('d-none', false)
    }
  }

  displayEditOnlyField(){
    // Resetting API Key Field
    this.editFieldTarget.value = '';

    this.editFieldContainerTarget.classList.toggle('d-none', false)
    if (this.hasToggleFieldTypeTarget){
      this.toggleFieldTypeTarget.classList.toggle('d-none', false)
    }

    this.editBtnTarget.classList.toggle('d-none', true)
    this.displayFieldTarget.classList.toggle('d-none', true)
    if (this.hasDeleteFieldContainerTarget){
      this.deleteFieldContainerTarget.classList.toggle('d-none', true)
    }
  }
}
